export class Controller {

    /** @ngInject */
    constructor(Alert, DestructiveOperationModal, DeviceManagement, ShowCloneCodeModal, ConfirmModal, $rootScope) {
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
        this.DeviceManagement = DeviceManagement;
        this.ShowCloneCodeModal = ShowCloneCodeModal;
        this.ConfirmModal = ConfirmModal;
        this.$rootScope = $rootScope;
    }

    $onInit() {
        this.isHardTokenUser = this.account.isSecondaryDeviceSession;
        this.userDevices = this.devices.userDevices;
        this.hardTokens = this.devices.hardTokens;
    }

    showDeleteDeviceDP(id) {
        this.DestructiveOperationModal({
            titleKey: 'device_management.delete_modal_header',
            textKey: 'device_management.delete_modal_content',
            http: {method: 'DELETE', url: `app/rest/device_management/${id}`}
        }).then(() => {
            const index = this.userDevices.findIndex(d => d.id === id);
            this.userDevices.splice(index, 1);
            this.Alert('success', 'device_management.messages.delete');
        });
    }

    generateCloneCode() {
        this.ConfirmModal({
            messageKey:'You can clone your SAASPASS ID to another device. <br><br>Download SAASPASS application to your other device and choose \'RECOVER or CLONE your SAASPASS ID\' at the bottom of the first screen after you create a PIN. <br><br>Then choose \'CLONE SAASPASS ID\' and then enter your SAASPASS ID and cloning code. <br><br>Click YES to generate cloning code which is valid for 15 minutes.',
            titleKey:'GENERATE CLONE CODE'
        })
            .then(() =>
                this.DeviceManagement.generateCloneCode().$promise
                .then((result) => {
                    this.ShowCloneCodeModal('CLONE SAASPASS ID', this.$rootScope.account.login, result.cloneCode);
                })
            )
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/device-management/device-management.controller.js